import { render, staticRenderFns } from "./SkockKittingDatailedDebitsBanner.vue?vue&type=template&id=71cb6941&scoped=true&"
import script from "./SkockKittingDatailedDebitsBanner.vue?vue&type=script&lang=js&"
export * from "./SkockKittingDatailedDebitsBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71cb6941",
  null
  
)

export default component.exports
import {QBanner,QIcon} from 'quasar'
component.options.components = Object.assign({QBanner,QIcon}, component.options.components || {})
